(function() {
    'use strict';
    angular.module('wbDashboard').directive('contentAurea', ['Display', function (Display) {
        return {
            restrict: 'A',
            transclude: true,
            replace: true,
            //scope: do not include so root scope is inherited for all views
            templateUrl: 'app/themes/aurea/directives/content/content.tpl.html',
            link: function (scope) {

            }
        };
    }]);
})();
